import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DatePipe } from "@angular/common";
import { ExamsService } from "../exams.service";
import { LoginService } from "../login.service";
import { PatientsService } from "../patients.service";

export interface PreviousReportTable {
  examId: number;
  creationDate: string;
  creationTime: string;
  examType: string;
  changedExamTitle: string;
  opener: string;
  signedDate: string;
}

@Component({
  selector: "app-exam-print-history",
  templateUrl: "./exam-print-history.component.html",
  styleUrls: ["./exam-print-history.component.scss"],
  standalone: false,
})
export class ExamPrintHistoryComponent implements OnInit {
  @Output() closed = new EventEmitter<void>();

  displayedColumns: string[] = ["position", "date", "time", "physician"];
  previousReports: PreviousReportTable[] = [];
  loadingPrint = false;
  hasError = false;

  constructor(
    private http: HttpClient,
    private datePipe: DatePipe,
    private ls: LoginService,
    private patServ: PatientsService,
    public es: ExamsService
  ) {}

  ngOnInit(): void {
    this.getPreviousReports();
  }

  getPreviousReports() {
    if (!this.es.examID) {
      return;
    }

    this.loadingPrint = true;
    this.hasError = false;

    this.http.get(`api/print-history/same-type/${this.es.examID.toString()}`).subscribe(
      (data: PreviousReportTable[]) => {
        data.forEach((element) => {
          element.creationTime = this.formatDateToUTC(element.creationDate);
        });

        this.previousReports = data;
        this.loadingPrint = false;
      },
      (err) => {
        console.warn(err);
        this.previousReports = [];
        this.hasError = true;
        this.loadingPrint = false;
      }
    );
  }

  openReport(selectRow: PreviousReportTable) {
    this.loadingPrint = true;
    this.hasError = false;

    const lang = this.ls.printLang ? this.ls.printLang : "he-IL";
    const pid = this.patServ.getPat().PID;

    this.http
      .get(`/api/printpdf/${selectRow.examId}/${pid}/${lang}/y/n/simple/2/last`, {
        responseType: "blob",
      })
      .subscribe(
        (data) => {
          const file = new Blob([data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.loadingPrint = false;
        },
        (err) => {
          console.warn(err);
          this.hasError = true;
          this.loadingPrint = false;
        }
      );
  }

  close() {
    this.closed.emit();
  }

  private formatDateToUTC(dateString: string): string {
    const date = new Date(dateString);
    const utcDate = new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
    return this.datePipe.transform(utcDate, "HH:mm", "Asia/Jerusalem");
  }
}
